import api from "./api";

export const listAdminConnections = async (query = {}) => {
  const { data } = await api.get("/admin/v1/connections", { params: query });
  return data;
};

export const showAdminConnection = async (id) => {
  const { data } = await api.get(`/admin/v1/connections/${id}`);
  return data;
};

export const diagnoseConnection = async (id) => {
  const { data } = await api.post(`/admin/v1/connections/${id}/diagnose`);
  return data;
};

export const restartConnectionSocket = async (id) => {
  const { data } = await api.post(`/admin/v1/connections/${id}/restart-socket`);
  return data;
};

export const repairConnection = async (id) => {
  const { data } = await api.post(`/admin/v1/connections/${id}/repair`);
  return data;
};

export const listAllCompanies = async () => {
  const { data } = await api.get("/admin/v1/announcements/companies");
  return data;
};
